import type { ActionDefinition } from '../types/ActionDefinition';

/**
 * Render slot for a single row action.
 * - 'icon'     — rendered as IconButton in action column
 * - 'overflow' — rendered as menu item in DropdownAction overflow menu
 * - 'excluded' — not rendered (bulk-only, or ROW_CLICK without icon)
 */
export type ActionRenderSlot = 'icon' | 'overflow' | 'excluded';

/**
 * Single source of truth for how an action renders, based on its definition.
 * Used by both partitionRowActions (per-row) and EagGridTable (aggregate column width).
 */
export function classifyRowAction(definition: ActionDefinition): ActionRenderSlot {
  if (!definition.singleAction) {
    return 'excluded';
  }
  const hasIcon = Boolean(definition.icon.value);
  if (hasIcon) {
    return 'icon';
  }
  return definition.type === 'ROW_CLICK' ? 'excluded' : 'overflow';
}